import { render, staticRenderFns } from "./EntranceMajor.vue?vue&type=template&id=2b702b6a&scoped=true&"
import script from "./EntranceMajor.vue?vue&type=script&lang=js&"
export * from "./EntranceMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b702b6a",
  null
  
)

export default component.exports